import {
  ENABLE_BODY_SCROLL,
  DISABLE_BODY_SCROLL
} from "../../modules/bodyScroll";

const hideOverflowClass = "chrome-bodylock-with-scrollbar";

export default () => {
  return next => action => {
    if (action.type === DISABLE_BODY_SCROLL) {
      document.body.classList.add(hideOverflowClass);
    }
    if (action.type === ENABLE_BODY_SCROLL) {
      document.body.classList.remove(hideOverflowClass);
    }
    next(action);
  };
};
